import React, { useEffect } from 'react'
import TractorSlider from './TractorSlider';
import { Tabs, Button } from 'antd';

const { TabPane } = Tabs;

const viewAll = <Button type="primary" >View All</Button>;


function TractorByBudget() {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="p-2">
                    <h2 className="text-2xl font-bold">Tractor by budget</h2>
                    
                    <Tabs defaultActiveKey="1" tabBarExtraContent={viewAll}>
                        <TabPane tab="Below 3Lac" key="1">
                            <TractorSlider lowBudget="0" highBudget="300000" />
                        </TabPane>

                        <TabPane tab="3 - 6Lac" key="2">
                            <TractorSlider lowBudget="300000" highBudget="600000" />
                        </TabPane>

                        <TabPane tab="6 - 10Lac" key="3">
                            <TractorSlider lowBudget="600000" highBudget="1000000" />
                        </TabPane>

                        <TabPane tab="Above 10Lac" key="4">
                            <TractorSlider lowBudget="1000000" highBudget="100000000" />
                        </TabPane>
                    </Tabs>
                    
                </div>
            </div>
            
        </div>
    );
}

export default TractorByBudget;
